import Label from 'components/Label';
import TextWithIcon from 'components/TextWithIcon';
import { ROUTES } from 'constants/routes';
import { Link } from 'react-router-dom';

const NewsCard = ({ data }) => {
    const { img, title, label, date, readTime, type } = data;

    return (
        <Link to={ROUTES.research} className={`news-card ${type ? 'news-card--big' : ''}`}>
            <div className="news-card__image">
                <img src={img} alt="news" />
            </div>
            <div className="news-card__content">
                <div className="news-card-labels">
                    <Label>{label}</Label>
                </div>
                <div className="news-card__title description-demibold">{title}</div>
                <div className="news-card-date">
                    <TextWithIcon iconName="calendar" text={date} />
                    <TextWithIcon iconName="clock" text={readTime} />
                </div>
            </div>
        </Link>
    );
};

export default NewsCard;
